import { render, staticRenderFns } from "./userMGT-list.vue?vue&type=template&id=56123b1b&scoped=true&"
import script from "./userMGT-list.vue?vue&type=script&lang=js&"
export * from "./userMGT-list.vue?vue&type=script&lang=js&"
import style0 from "./userMGT-list.vue?vue&type=style&index=0&id=56123b1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56123b1b",
  null
  
)

export default component.exports